// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3CKxK","list":"styles_list__RgM31"};